import { Box, SxProps, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { IconTypes } from "../../components/icons.types";
import HelpButton from "../../components/buttons/HelpButton";

type Props = {
  title: string;
  subtitle?: string;
  backUrl?: string;
  backLabel?: string;
  helpUrl?: string;
  children: React.ReactNode;
  sx?: SxProps;
  justifyContent?: string;
  compact?: boolean;
};

export const Page = ({
  title,
  subtitle,
  children,
  sx,
  backUrl,
  helpUrl,
  backLabel,
  justifyContent = "center",
  compact = false,
}: Props) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        overflow: "auto",
        p: 3,
        pt: compact ? 1.5 : 3,
        backgroundColor: "darkBackground",
        height: "100%",
      }}
    >
      <Box sx={{ ...sx }}>
        {backUrl && (
          <Button
            onClick={() => navigate(backUrl)}
            startIcon={<IconTypes.ArrowBack />}
            size="small"
            sx={{ mb: 2 }}
          >
            {backLabel || "Back"}
          </Button>
        )}
        <Box
          sx={{
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent,
            gap: 1,
            mb: subtitle ? 1 : compact ? 1 : 3,
            mt: compact ? 0 : 1,
          }}
        >
          <Typography
            variant={compact ? "h6" : "h4"}
            component="h1"
            sx={{
              color: "textPrimary",

              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {title}
          </Typography>
          {helpUrl && <HelpButton helpUrl={helpUrl} />}
        </Box>
        {subtitle && (
          <Box sx={{ textAlign: "center" }}>
            <Typography
              variant="subtitle1"
              color="textSecondary"
              sx={{ mb: 3 }}
            >
              {subtitle}
            </Typography>
          </Box>
        )}
        {children}
      </Box>
    </Box>
  );
};
